import { Checkbox, makeStyles } from '@material-ui/core';

import { DefaultCommandProps } from './index';

export interface CheckboxProps extends DefaultCommandProps {
  checked: boolean;
}

const useStyles = makeStyles(() => ({
  checkbox: {
    alignItems: 'center',
    display: 'flex',
    padding: 0,
  },
  checkboxContainer: {
    height: '100%',
  },
}));

const CheckboxUI = ({ checked, onChange, label }: CheckboxProps) => {
  const classes = useStyles();

  return (
    <Checkbox
      checked={checked}
      className={classes.checkbox}
      color="primary"
      onChange={(e) => onChange(label, e.target.value)}
    />
  );
};

export default CheckboxUI;
